import { render, staticRenderFns } from "./MarketStock.vue?vue&type=template&id=603bc7fe&scoped=true&"
import script from "./MarketStock.vue?vue&type=script&lang=js&"
export * from "./MarketStock.vue?vue&type=script&lang=js&"
import style0 from "./MarketStock.vue?vue&type=style&index=0&id=603bc7fe&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603bc7fe",
  null
  
)

export default component.exports